export default (function citiesInit() {
    const auth_actions = {
        addPhone() {
           $('.js--add_phone').click(function() {
               const $newField = $('.js--extra_phone.hidden').clone().removeClass('hidden');
               $(this).before($newField);
               $('.js--phone-num').mask('+38 (099) 999-99-99');
           });
        },
    };
    $(document).ready(() => {
        // cities.initModal();
        auth_actions.addPhone();
    });
}());
